/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Legal_Validation_FailedInputs */

const en_admin_legal_validation_failed = /** @type {(inputs: Admin_Legal_Validation_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Validation failed`)
};

const de_admin_legal_validation_failed = /** @type {(inputs: Admin_Legal_Validation_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Validierung fehlgeschlagen`)
};

/**
* | output |
* | --- |
* | "Validation failed" |
*
* @param {Admin_Legal_Validation_FailedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_legal_validation_failed = /** @type {((inputs?: Admin_Legal_Validation_FailedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Legal_Validation_FailedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_admin_legal_validation_failed(inputs)
	return en_admin_legal_validation_failed(inputs)
});